import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, LeafIcon, GraduationCapIcon } from 'lucide-react';
export function TrustSection() {
  const pillars = [{
    icon: BookOpenIcon,
    title: 'Einfach erklärt',
    description: 'Gesundheitswissen in klarer, verständlicher Sprache – ohne Fachchinesisch.'
  }, {
    icon: LeafIcon,
    title: 'Natürlich gedacht',
    description: 'Wir setzen auf natürliche Ansätze und ganzheitliches Verständnis.'
  }, {
    icon: GraduationCapIcon,
    title: 'Basierend auf Wissen & Erfahrung',
    description: 'Unsere Inhalte basieren auf aktueller Forschung und praktischer Erfahrung.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-vita-green-pale border-y border-vita-green-light" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-221">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <motion.div key={index} variants={itemVariants} className="flex flex-col items-center text-center px-4" data-id="element-222">
                <div className="w-16 h-16 rounded-full bg-white shadow-sm flex items-center justify-center mb-6 text-vita-green-deep" data-id="element-223">
                  <Icon className="w-8 h-8" strokeWidth={1.5} data-id="element-224" />
                </div>
                <h3 className="text-xl font-bold text-vita-text mb-4 font-heading" data-id="element-225">
                  {pillar.title}
                </h3>
                <p className="text-vita-text-muted leading-relaxed" data-id="element-226">
                  {pillar.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}